import { Label } from 'semantic-ui-react';

interface RidershipMapLegendProps {
    mapMode?: 'bubble' | 'heat';
    heatMetric?: string;
}

function formatHeatMetricLabel(heatMetric?: string) {
    if (heatMetric === 'boarding') {
        return 'Boardings';
    }
    if (heatMetric === 'alighting') {
        return 'Alightings';
    }
    if (heatMetric === 'load') {
        return 'Load';
    }
    return 'Selected metric';
}

const RidershipMapLegend = ({ mapMode = 'bubble', heatMetric }: RidershipMapLegendProps) => {
    const isHeatMode = mapMode === 'heat';

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
            <Label basic size="small">Legend</Label>
            {!isHeatMode
                ? (
                    <>
                        <span>
                            <Label color="green" empty circular /> Boardings
                        </span>
                        <span>
                            <Label color="orange" empty circular /> Alightings
                        </span>
                        <span>
                            <Label color="blue" empty circular /> Load
                        </span>
                    </>
                )
                : null}
            {isHeatMode
                ? (
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                        <Label basic size="small">Heat ({formatHeatMetricLabel(heatMetric)})</Label>
                        <span style={{ fontSize: 12, color: '#6b7280' }}>Low</span>
                        <span style={{
                            display: 'inline-block',
                            width: 90,
                            height: 8,
                            borderRadius: 6,
                            background: 'linear-gradient(90deg, #2f89fc 0%, #2f89fc 10%, #f1c40f 55%, #e67e22 78%, #c0392b 100%)',
                        }}/>
                        <span style={{ fontSize: 12, color: '#6b7280' }}>High</span>
                    </span>
                )
                : null}
        </div>
    );
};

export default RidershipMapLegend;
